module.exports = __webpack_public_path__ + "static/media/здоровая-спина.705e7939.jpg";